import { useRef } from 'react';
import { trpc } from '../utils/trpc/trpc.ts';


export function useGetLogin() {
    const queryIsLoggedIn = trpc.user.isLoggedIn.useQuery(undefined, {
        refetchInterval: (q) => (q.state.status === 'error' ? 5_000 : 60_000),
    });
    const queryIsAdmin = trpc.user.isAdmin.useQuery(undefined, {
        refetchInterval: (q) => (q.state.status === 'error' ? 5_000 : 60_000),
    });

    const isLoggedIn = queryIsLoggedIn.data;
    const isAdmin = isLoggedIn && queryIsAdmin.data;

    const dataIsMissing = queryIsLoggedIn.data === undefined || queryIsAdmin.data === undefined;
    const dataIsLoading = queryIsLoggedIn.isLoading || queryIsAdmin.isLoading;
    const hasError = queryIsLoggedIn.error || queryIsAdmin.error;

    // synchronous persistence — no render delay
    const firstLoadErrorRef = useRef(false);
    if (!dataIsMissing) firstLoadErrorRef.current = false;
    else if (dataIsMissing && hasError && !dataIsLoading) firstLoadErrorRef.current = true;

    const inFirstLoadError = firstLoadErrorRef.current;
    const isFirstLoading = !inFirstLoadError && dataIsMissing && dataIsLoading;

    return {
        isLoggedIn,
        isAdmin,
        isFirstLoading,
        inFirstLoadError,
    };
}
